module.exports = {"classes":["jp-dashboard-page","header-dark"],"title":"Dashboard","metas":{},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/how-it-works/metadata.json
// module id = 1519
// module chunks = 0